module.exports = __webpack_public_path__ + "static/4-f76e9e91d2176433f4716e5b75f2cfab.jpg";